export const TEAM_ROLE_ORDER = ['Player', 'Coach', 'Analyst', 'Sub', 'Manager', 'Spectator', 'Trialing'];
export function teamRoleLabel(value) {
  const role = String(value || '').trim().toLowerCase();
  if (role === 'manger') return 'Manager';
  return TEAM_ROLE_ORDER.find(label => role.startsWith(label === 'Trialing' ? 'trial' : label.toLowerCase())) || 'Spectator';
}
export function teamRoleColor(value) {
  const role = teamRoleLabel(value).toLowerCase();
  return `var(--color-role-${role === 'trialing' ? 'trial' : role})`;
}
